import styled from "styled-components";

export const IconWrapper = styled.svg`
  width: 48px;
  height: 22px;
  -webkit-transition-property: height;
  -webkit-transition-duration: .5s;
  -moz-transition-property: height;
  -moz-transition-duration: .5s;
  transition-property: height;
  transition-duration: .5s;
`;

export const BackToTopIcon = () => (
  <IconWrapper aria-hidden="true">
    <path
      fill="#e0e0e0"
      d="M37.678,26.602h-2.356c-0.73,0-1.322-0.592-1.322-1.322v-5.957C34,18.592,34.592,18,35.322,18h2.356	C38.408,18,39,18.592,39,19.322v5.957C39,26.01,38.408,26.602,37.678,26.602z"
    />
    <path
      fill="#e0e0e0"
      d="M12.678,26.602h-2.356C9.592,26.602,9,26.01,9,25.28v-5.957C9,18.592,9.592,18,10.322,18h2.356	C13.408,18,14,18.592,14,19.322v5.957C14,26.01,13.408,26.602,12.678,26.602z"
    />
    <rect width="28" height="17" x="10" y="18" fill="#e0e0e0" />
    <path
      fill="#bdbdbd"
      d="M32.799,37.992l4.771,2.153l3.035-6.727c1.189-2.635,0.017-5.735-2.619-6.924l0,0L32.799,37.992z"
    />
    <path
      fill="#e0e0e0"
      d="M38,17H10v0c0-7.18,5.82-13,13-13h2C32.18,4,38,9.82,38,17L38,17z"
    />
    <path
      fill="#bdbdbd"
      d="M19.514,26.694c1.253-1.056,2.847-1.637,4.486-1.637s3.232,0.581,4.486,1.638l7.17,6.039	l-4.897,4.744L14,34.543l-1.836-1.661L19.514,26.694z"
    />
    <path
      fill="#bdbdbd"
      d="M28.173,6.628c1.41,1.667,2.409,3.692,2.836,5.921c0.245,1.277-0.781,2.45-2.081,2.45l-16.946,0	c-1.094,0-1.98,0.886-1.982,1.98L10,17h28c0-5.6-3.542-10.368-8.507-12.196C28.363,4.388,27.396,5.709,28.173,6.628z"
    />
    <path
      fill="#f5f5f5"
      d="M38,18H10v1.387c0,1.566,0.335,3.114,0.984,4.54l0,0c0.403,0.906,1.135,1.6,2.063,1.951	c0.426,0.162,0.87,0.243,1.312,0.242c0.52,0,1.039-0.111,1.526-0.333l5.98-3.79c1.354-0.632,2.918-0.632,4.272,0l5.979,3.79	c0.903,0.41,1.911,0.442,2.838,0.091c0.927-0.352,1.66-1.045,2.068-1.964v0C37.667,22.405,38,20.78,38,19.138V18z"
    />
    <path
      fill="#bdbdbd"
      d="M15.191,38.022l-4.771,2.153l-3.035-6.727c-1.189-2.635-0.017-5.735,2.619-6.924l0,0L15.191,38.022z"
    />
    <path
      fill="#263238"
      d="M20.802,27.225l-7.661,6.448L24,33.531l10.757,0.061l-7.56-6.368	C25.35,25.668,22.65,25.668,20.802,27.225z"
    />
    <path
      fill="#263238"
      d="M13,19c-0.248,0.918-0.055,1.916,0.436,2.966c0.324,0.694,1.029,1.175,1.795,1.172	c2.238-0.008,4.3-1.429,6.271-3.578c0.195-0.213,0.04-0.56-0.249-0.56H13"
    />
    <path
      fill="#263238"
      d="M35,19c0.248,0.918,0.055,1.916-0.436,2.966c-0.324,0.694-1.029,1.175-1.795,1.172	c-2.238-0.008-4.3-1.429-6.271-3.578c-0.195-0.213-0.04-0.56,0.249-0.56H35"
    />
    <path
      fill="#455a64"
      d="M25,26.17c-0.661-0.136-1.339-0.136-2,0V32h2V26.17z"
    />
    <path
      fill="#455a64"
      d="M20.802,27.225L19,28.743V32h2v-4.913C20.936,27.136,20.865,27.172,20.802,27.225z"
    />
    <path
      fill="#455a64"
      d="M29,28.743l-1.802-1.518c-0.063-0.053-0.133-0.089-0.198-0.138V32h2V28.743z"
    />
    <path
      fill="#e0e0e0"
      d="M37.609,34.831l-11.658-5.399c-0.619-0.287-1.285-0.43-1.951-0.43s-1.331,0.143-1.951,0.43	l-11.658,5.399C9.534,35.314,9,36.25,9,37.268c0,2.635,1.517,4.887,3.676,5.9c3.324,1.558,6.813,0.52,7.589-0.469	c0.441-0.562,1.24-0.693,1.949-0.693H24h1.786c0.709,0,1.508,0.13,1.949,0.693c0.776,0.989,4.265,2.027,7.589,0.469	c2.159-1.012,3.676-3.265,3.676-5.9C39,36.25,38.466,35.314,37.609,34.831z"
    />
    <path
      fill="#bdbdbd"
      d="M21.639,36.842L21.639,36.842c-0.785,1.832-2.779,2.895-4.71,2.403	c-1.63-0.415-3.507-0.449-4.616,1.003c-0.289,0.378-0.401,0.826-0.361,1.311c0.074,0.914,0.763,1.682,1.633,1.972	c2.814,0.936,5.559,0.191,6.499-0.641c0.514-0.455,1.444-0.883,2.131-0.883l1.786,0V36h-1.084C22.36,36,21.858,36.331,21.639,36.842	z"
    />
    <path
      fill="#f5f5f5"
      d="M32.735,43.698c-0.441-0.562-1.24-0.693-1.949-0.693H29h-0.931c0.855,0.633,2.73,1.168,4.839,0.874	C32.84,43.82,32.782,43.759,32.735,43.698z"
    />
    <path
      fill="#f5f5f5"
      d="M32.735,43.698c-0.441-0.562-1.24-0.693-1.949-0.693H29h-0.931c0.855,0.633,2.73,1.168,4.839,0.874	C32.84,43.82,32.782,43.759,32.735,43.698z"
    />
    <path
      fill="#bdbdbd"
      d="M26.304,36.842L26.304,36.842c0.785,1.832,2.779,2.895,4.71,2.403	c1.63-0.415,3.507-0.449,4.616,1.003c0.395,0.517,0.459,1.166,0.258,1.858c-0.18,0.618-0.66,1.107-1.263,1.331	c-2.905,1.077-5.796,0.31-6.765-0.548c-0.514-0.455-1.444-0.883-2.131-0.883l-1.786,0V36h1.084	C25.583,36,26.086,36.331,26.304,36.842z"
    />
    <path
      fill="#263238"
      d="M23.5,44L23.5,44c-0.276,0-0.5-0.224-0.5-0.5v-6c0-0.276,0.224-0.5,0.5-0.5l0,0	c0.276,0,0.5,0.224,0.5,0.5v6C24,43.776,23.776,44,23.5,44z"
    />
    <path
      fill="#263238"
      d="M22.577,43h-0.155C22.189,43,22,42.811,22,42.577v-4.155C22,38.189,22.189,38,22.423,38h0.155	C22.811,38,23,38.189,23,38.423v4.155C23,42.811,22.811,43,22.577,43z"
    />
    <path
      fill="#263238"
      d="M21.5,42L21.5,42c-0.276,0-0.5-0.224-0.5-0.5v-2c0-0.276,0.224-0.5,0.5-0.5l0,0	c0.276,0,0.5,0.224,0.5,0.5v2C22,41.776,21.776,42,21.5,42z"
    />
    <path
      fill="#263238"
      d="M24.5,44L24.5,44c0.276,0,0.5-0.224,0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5l0,0	c-0.276,0-0.5,0.224-0.5,0.5v6C24,43.776,24.224,44,24.5,44z"
    />
    <path
      fill="#263238"
      d="M25.423,43h0.155C25.811,43,26,42.811,26,42.577v-4.155C26,38.189,25.811,38,25.577,38h-0.155	C25.189,38,25,38.189,25,38.423v4.155C25,42.811,25.189,43,25.423,43z"
    />
    <path
      fill="#263238"
      d="M26.5,42L26.5,42c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5l0,0	c-0.276,0-0.5,0.224-0.5,0.5v2C26,41.776,26.224,42,26.5,42z"
    />
    <rect width="28" height="2" x="10" y="16" fill="#263238" />
    <path
      fill="#263238"
      d="M14.526,39.038L15,42l1.5-1v-1.849C15.845,39.016,15.169,38.957,14.526,39.038z"
    />
    <path
      fill="#263238"
      d="M18.419,39.323c-0.487,0.068-0.99,0.049-1.49-0.079c-0.141-0.036-0.285-0.064-0.429-0.094V41l1.5,1	L18.419,39.323z"
    />
    <ellipse cx="16.5" cy="42" fill="#455a64" rx="1.5" ry="1" />
    <path
      fill="#263238"
      d="M33.419,39.038L32.946,42l-1.5-1v-1.849C32.101,39.016,32.777,38.957,33.419,39.038z"
    />
    <path
      fill="#263238"
      d="M29.526,39.323c0.487,0.068,0.99,0.049,1.49-0.079c0.141-0.036,0.285-0.064,0.429-0.094V41l-1.5,1	L29.526,39.323z"
    />
    <ellipse cx="31.446" cy="42" fill="#455a64" rx="1.5" ry="1" />
  </IconWrapper>
);
